export enum FieldToAdjust {
    DOWNPAYMENT = 'downPayment',
    SELLING_PRICING = 'sellingPrice'
}
